import React from 'react';
import XMLViewer from 'react-xml-viewer'
import {LOCALSTORAGE} from '../../const/C'

const xml = '<info>Данные отсутствуют</info>'
/**
 * Специальный компонент, который проксирует XMLViewer для получения данных из роутера
 */

class XSDViewerProxy extends React.Component {
  
  render() {
    //console.log(this);
    const {content}= this.props;
    const xsd = localStorage.getItem(LOCALSTORAGE.XSD);
    //Взять данные либо из состояния, либо из localStorage
    const value = (content==undefined)? ((xsd==undefined)?xml:xsd):content;
    return (
      <div>
        <XMLViewer xml={value} />
      </div>
    )
  }
}

export default XSDViewerProxy;